//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchPlaceById, storeDummyPlace } from '../../../redux/actions/placeActions';
import { setSelectedPlaceId } from '../../../redux/actions/selectedPlaceActions';
import { openLoginModal } from '../../../redux/actions/authActions';
// import { openModal } from '../../../redux/actions/modalAction';
import {
  setServiceModalConfig,
  openServicesModal,
} from '../../../redux/actions/addToDayModalactions';
import { withTrekEditInfo } from '../../../HOCs/withTrekEditInfo';
import withTrekPermission from '../../../HOCs/withTrekPermission';

// import { retrieveFromQueryParams } from "../../../lib/retrieveQueryParams";

type Props = {
  showAddButton: Boolean,
  patchInfo: {
    placeId: string,
  },
  editInfo: Object,
  setSelectedPlaceId: Function,
  storeDummyPlace: Function,
  openLoginModal: Function,
  openServicesModal: Function,
  setServiceModalConfig: Function,
};

class AddEntity extends Component<Props> {
  render() {
    const { className } = this.props;
    return (
      <div
        className={
          className
            ? className
            : 'card add d-flex align-items-center justify-content-center'
        }
        onClick={this.opensModal}
      >
        <span className="icon">
          <i className="icon-hg-plus" />
        </span>
        <p className="card-title my-2">{this.props.text}</p>
      </div>
    );
  }

  opensModal = () => {
    const {
      patchInfo,
      edit,
      setServiceModalConfig,
      setSelectedPlaceId,
      storeDummyPlace,
      openServicesModal,
      theme,
    } = this.props;
    const { placeId } = patchInfo;

    setServiceModalConfig({
      patchInfo,
      modalType: 'serviceModal',
      theme: theme ? theme : 'sightings',
    });
    setSelectedPlaceId({ id: placeId });
    storeDummyPlace(placeId);
    openServicesModal();
    //everytime the user click on add button, if the user is not logged in or has no necessary permission,
    //this modal pops up which is pretty annoying
    //following opens the permission info modal.

    if (edit.edit) setTimeout(() => edit.edit({ message: edit.message }), 500);
  };
}

const EnhancedComponent = connect(
  null,
  {
    setServiceModalConfig,
    setSelectedPlaceId,
    storeDummyPlace,
    openServicesModal,
    fetchPlaceById,
    openLoginModal,
    // openModal,
  }
)(AddEntity);

export default withTrekPermission(withTrekEditInfo(EnhancedComponent));



// WEBPACK FOOTER //
// ./src/screens/Trek/DayTrail/AddEntity.js